export const T = {
  en_GB: {
    settings: "Settings",
    webhooks: "Webhooks",
    pageDescription: "Configure webhooks to receive real-time event notifications",
    documentation: "Documentation",
  },
  nb_NO: {
    settings: "Innstillinger",
    webhooks: "Webhooks",
    pageDescription: "Konfigurer webhooks for å motta sanntids hendelsesvarslinger",
    documentation: "Dokumentasjon",
  },
} as const;
